import './promise.js'
import '@fontsource/clear-sans'

import VeeValidate, { Validator } from 'vee-validate'

import App from './App'
import ErrorContainer from '@/components/ErrorContainer'
import Vue from 'vue'
import VueBus from 'vue-bus'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'
import de from 'vee-validate/dist/locale/de'
import iView from 'iview'
import router from './router'
import store from './stores'

Vue.config.productionTip = false

Vue.use(iView)
Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(VueBus)

Vue.component('ErrorContainer', ErrorContainer)

Validator.localize('de', de)

Vue.use(VeeValidate, {
  events: 'input|blur|on-blur|on-open-change',
  fieldsBagName: 'fieldsInBag',
  locale: 'de'
})

const i18n = new VueI18n({
  locale: navigator.language.substr(0, 2),
  messages: {}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})
